import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { DISCOVERY_MODEL_CONTEXT } from './core/discovery-model-context.token';
import { DiscoveryPageTools } from './discovery-assignment/discovery-page-tools.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAppInitializer(() => {
      if (inject(DISCOVERY_MODEL_CONTEXT)) void inject(DiscoveryPageTools).register();
    }),
    provideRouter(routes),
  ],
};
